<template>
    <div>
        <rkm-form ref="FormDocumentacao">
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.cpf"
                        label="CPF"
                        v-mask="mask.cpf"
                        v-model="form.documentacao.cpf"
                    />
                </rkm-col>

                <rkm-col
                    v-if="localShowDnv"
                    cols="3"
                >
                    <rkm-form-input
                        :validations="validations.dnv"
                        label="DNV - Declaração de Nascido Vivo"
                        v-mask="mask.dnv"
                        v-model="form.documentacao.dnv"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-form ref="FormIdentificacao">
            <rkm-row>
                <rkm-col cols="9">
                    <rkm-form-input
                        uppercase
                        label="Nome"
                        v-model="form.identificacao.nome"
                        :validations="validations.nome"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-date-picker
                        :validations="validations.dataNascimento"
                        :max-date="dataAtual"
                        label="Data de nascimento"
                        v-model="form.identificacao.dataNascimento"
                        right
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        uppercase
                        label="Nome da mãe"
                        v-model="form.identificacao.nomeMae"
                        :validations="validations.nomeMae"
                        :disabled="form.identificacao.desconheceNomeMae"
                    >
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-checkbox v-model="form.identificacao.desconheceNomeMae">
                                    Desconhece
                                </rkm-form-checkbox>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <ModalResultado
            ref="ModalResultado"
            :cidadaos="form.cidadaos"
            :pacientes="form.pacientes"
            :usuarios="form.usuarios"
            :hide-cidadaos="hideCidadaos"
            :show-pacientes="showPacientes"
            :show-usuarios="showUsuarios"
            :onContinue="onContinue"
            @select-cidadao="handleSelected('cidadao', $event)"
            @select-usuario="handleSelected('usuario', $event)"
            @select-paciente="handleSelected('paciente', $event)"
            @continue="handleContinue"
            @close="resetForms"
        />
    </div>
</template>

<script>
// Components.
import ModalResultado from './busca/resultado/Modal'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, mask, unmask, data, object } from '@/mixins'

// Moment.
import moment from 'moment'

export default {
    props: {
        additionals: { type: Object, required: true, default: () => ({}) },
        dataAtual: { type: String, required: true },
        hideCidadaos: { type: Boolean, default: false },
        onContinue: { type: Function, required: true },
        showDnv: { type: Boolean, default: false },
        showPacientes: { type: Boolean, default: false },
        showUsuarios: { type: Boolean, default: false },
        termosInvalidos: { type: Array, required: true },
    },
    components: {
        ModalResultado,
    },
    mixins: [
        repository,
        error,
        mask,
        unmask,
        data,
        object,
    ],
    data: () => ({
        repositories: {
            cidadao: null,
        },
        form: {
            documentacao: {
                cpf: '',
                dnv: '',
            },
            identificacao: {
                nome: '',
                dataNascimento: null,
                nomeMae: '',
                desconheceNomeMae: false,
            },
            cidadaos: [],
            usuarios: [],
            pacientes: [],
        },
        timeoutForms: null,
        itemSelected: false,
        continuing: false,
    }),
    computed: {
        validations() {

            return {
                cpf: {
                    required: this.exigeCpf,
                    min_max_without_mask: 11,
                    cpf: true
                },
                dnv: {
                    min_max_without_mask: 11,
                },
                nome: {
                    required: true,
                    min: 6,
                    max: 150,
                    termo_invalido: this.termosInvalidos,
                    name: true,
                },
                dataNascimento: {
                    required: true,
                },
                nomeMae: {
                    required: !this.form.identificacao.desconheceNomeMae,
                    min: 8,
                    max: 150,
                    termo_invalido: this.termosInvalidos,
                    name: true,
                },
            }
        },
        localShowDnv() {

            if (this.showDnv) {

                if (this.form.identificacao.dataNascimento) {

                    return moment(this.dataAtual, 'DD/MM/YYYY').diff(moment(this.form.identificacao.dataNascimento), 'days') <= 15
                }
            }

            return false
        },
        exigeCpf() {

            const exigeCpfPaciente = this.additionals.exigeCpfPaciente ?? true

            return this.showDnv && !!this.form.documentacao.dnv ? false : exigeCpfPaciente
        },
    },
    watch: {
        'form.documentacao': {
            deep: true,
            handler(documentacao) {

                this.delaySearch(() => {

                    this.$refs.FormDocumentacao.validateSilent()
                        .then(valid => {

                            if (!valid) return

                            this.$emit('form-change', {
                                ...this.clone(this.form.identificacao),
                                cpf: documentacao.cpf,
                                dnv: documentacao.dnv,
                            })

                            this.loadDataFromDocumentacao()
                        })
                })
            }
        },
        'form.identificacao': {
            deep: true,
            handler(identificacao) {

                if (identificacao.desconheceNomeMae) {

                    this.form.identificacao.nomeMae = ''
                }

                this.delaySearch(() => {

                    this.$refs.FormIdentificacao.validateSilent()
                        .then(valid => {

                            if (!valid) return

                            this.$emit('form-change', {
                                ...this.clone(identificacao),
                                cpf: this.form.documentacao.cpf,
                                dnv: this.form.documentacao.dnv,
                            })

                            this.loadDataFromIdentificacao()
                        })
                })
            }
        },
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        async validate() {

            if (this.itemSelected || this.continuing) {

                return true
            }

            const identificacaoValid = await this.$refs.FormIdentificacao.validate()
            const documentacaoValid = await this.$refs.FormDocumentacao.validate()

            return documentacaoValid && identificacaoValid
        },
        resetForms() {

            this.resetFormDocumentacao()
            this.resetFormIdentificacao()
        },
        resetFormDocumentacao() {

            this.form.documentacao.cpf = ''
            this.form.documentacao.dnv = ''

            this.$nextTick(() => this.$refs.FormDocumentacao.resetValidator())
        },
        resetFormIdentificacao() {

            this.form.identificacao.nome = ''
            this.form.identificacao.dataNascimento = null
            this.form.identificacao.nomeMae = ''
            this.form.identificacao.desconheceNomeMae = false

            this.$nextTick(() => this.$refs.FormIdentificacao.resetValidator())
        },
        handleSelected(item, data) {

            this.itemSelected = true

            this.$emit(`select-${item}`, data)
        },
        handleContinue() {

            this.continuing = true

            this.onContinue()
        },
        delaySearch(callback) {

            this.itemSelected = false

            if (this.timeoutForms !== null) {

                clearTimeout(this.timeoutForms)
            }

            this.$emit('searching', true)

            this.timeoutForms = setTimeout(() => {

                callback()

                this.$emit('searching', false)
            }, 500)
        },
        loadDataFromDocumentacao() {

            this.setLoading()

            this.repositories.cidadao.index({
                with_usuarios: this.showUsuarios,
                with_pacientes: this.showPacientes,
                with_cidadaos: !this.hideCidadaos,
                cpf: this.unMaskCpf(this.form.documentacao.cpf),
                dnv: this.unMaskDnv(this.form.documentacao.dnv)
            })
                .then(({ data }) => data.found && this.loadData(data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadDataFromIdentificacao() {

            this.setLoading()

            this.repositories.cidadao.index({
                with_usuarios: this.showUsuarios,
                with_pacientes: this.showPacientes,
                with_cidadaos: !this.hideCidadaos,
                nome: this.form.identificacao.nome,
                data_nascimento: this.getFormatedDate(this.form.identificacao.dataNascimento),
                nome_mae: this.form.identificacao.nomeMae
            })
                .then(({ data }) => data.found && this.loadData(data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async loadData(data) {

            if (this.showUsuarios) {

                this.form.usuarios = data.usuarios
            }

            if (this.showPacientes) {

                this.form.pacientes = data.pacientes
            }

            if (!this.hideCidadaos) {

                this.form.cidadaos = data.cidadaos
            }

            this.$refs.ModalResultado.open()
        },
    },
    created() {

        this.repositories.cidadao = this.getConectaSusRepository('cadastro.sujeitoAtencao.cidadao')
    },
}
</script>